module.exports = __webpack_public_path__ + "media/img/event/Citibank-logo-transparent-17dd1a7c50707eb7e8b3200c203f475b.png";